module.exports = __webpack_public_path__ + "img/i4.a4550a93.png";